import { render } from "./About.vue?vue&type=template&id=16cce598&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=16cce598&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-16cce598"

export default script